import React from "react";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import "../theme/washPackages.css";
import washPackagesJSON from "../data/washPackages.json";

const WashPackages = () => {
  const squeakyCleanHTML = [];
  const numPackages = washPackagesJSON.length;
  const washPackagesHTML = washPackagesJSON.map(washPackage => {
    const {
      id,
      name,
      caption,
      price,
      payout,
      cut,
      features,
      specialFeatures,
      duration,
      accentColor
    } = washPackage;
    const arrayToUse =
      specialFeatures && specialFeatures.length > 0
        ? specialFeatures
        : features;

    const featuresHTML = arrayToUse.map((feature, index) => {
      const { name } = feature;
      // const iconImage = Utils.getPackageImageForIconIndex(icon);
      const key = `feature_${id}_${index}`;
      // const backgroundSize = icon === 2 ? "80%" : "";

      return <li key={key}>{name}</li>;
    });

    return (
      <div key={id} className="packageInfo">
        <h3 style={{ backgroundColor: accentColor }}>{name}</h3>
        <h5 style={{ backgroundColor: accentColor }}>{duration}</h5>
        <h4>
          <FormattedMessage id="WashPackages.YourPayout" />
        </h4>
        <h1>{payout}</h1>
        <div>
          <h4>
            <FormattedMessage id="WashPackages.OurFee" />
          </h4>
          <h3>{cut}</h3>
        </div>
        <div>
          <h4>
            <FormattedMessage id="WashPackages.CustomerPrice" />
          </h4>
          <h3>{price}</h3>
        </div>
        {caption ? (
          <div style={{ width: "auto", display: "block" }}>
            <h4 className="caption">
              <FormattedMessage id="WashPackages.IncludesPlus" />
            </h4>
            <div className="packageFeaturesGridMini">{squeakyCleanHTML}</div>
          </div>
        ) : (
          <h4 className="caption">
            <FormattedMessage id="WashPackages.Includes" />
          </h4>
        )}
        <ul>{featuresHTML}</ul>
      </div>
    );

    // const featuresHTML = arrayToUse.map((feature, index) => {
    //   const { name, icon } = feature;
    //   const iconImage = Utils.getPackageImageForIconIndex(icon);
    //   const key = `feature_${id}_${index}`;
    //   const backgroundSize = icon === 2 ? "80%" : "";

    //   if (id === "1squeakyclean") {
    //     squeakyCleanHTML.push(
    //       <div key={key} className="packageFeature">
    //         <div
    //           className="packageFeatureIcon"
    //           style={{
    //             backgroundImage: `url(${iconImage})`,
    //             backgroundSize: backgroundSize
    //           }}
    //           alt={name}
    //         />
    //       </div>
    //     );
    //   }

    //   return (
    //     <div key={key} className="packageFeature">
    //       <div
    //         className="packageFeatureIcon"
    //         style={{
    //           backgroundImage: `url(${iconImage})`,
    //           backgroundSize: backgroundSize
    //         }}
    //         alt={name}
    //       />
    //       <div className="container">
    //         <p>{name}</p>
    //       </div>
    //     </div>
    //   );
    // });

    // return (
    //   <div className="package" key={`package_${id}`}>
    //     <h2>{name}</h2>
    //     <table className="tablePackages" cellSpacing="0">
    //       <tbody>
    //         <tr>
    //           <td>
    //             <table style={{ width: "80%", margin: "0 auto" }}>
    //               <thead>
    //                 <tr>
    //                   <th>Customer Price</th>
    //                   <th>Your Payout</th>
    //                   <th>Our Fee</th>
    //                 </tr>
    //               </thead>
    //               <tbody>
    //                 <tr>
    //                   <td>
    //                     <h2>{price}</h2>
    //                   </td>
    //                   <td>
    //                     <h2>{payout}</h2>
    //                   </td>
    //                   <td>
    //                     <h2>{cut}</h2>
    //                   </td>
    //                 </tr>
    //               </tbody>
    //             </table>
    //           </td>
    //         </tr>

    //         {caption ? (
    //           <tr>
    //             <td>
    //               <h4 style={{ textAlign: "center" }}>{caption}</h4>
    //               <div className="packageFeaturesGridMini">
    //                 {squeakyCleanHTML}
    //               </div>
    //               <h4 style={{ textAlign: "center" }}>Plus</h4>
    //             </td>
    //           </tr>
    //         ) : null}
    //         <tr>
    //           <td>
    //             <div className="packageFeaturesGrid">{featuresHTML}</div>
    //           </td>
    //         </tr>
    //       </tbody>
    //     </table>
    //   </div>
    // );
  });

  return (
    <div>
      <h1>
        <FormattedMessage id="WashPackages.Title" />
      </h1>
      <FormattedHTMLMessage
        id="WashPackages.Content"
        values={{ NUM_PACKAGES: numPackages }}
      />
      {washPackagesHTML}
    </div>
  );
};

export default WashPackages;



// WEBPACK FOOTER //
// ./src/components/WashPackages.js